import { Avatar, Tooltip } from "@mui/material";
import React from "react";
import { configs } from "../../../app/app-configs";

interface ProfileImageProps {
    readonly profileImageKey: string;
}

const ProfileImage: React.FC<ProfileImageProps> = ({ profileImageKey }) => {
    return (
        <Tooltip
            title={
                <img
                    src={profileImageKey ? `${configs.FILE_UPLOAD_S3_URL}/${profileImageKey}` : `${configs.FILE_UPLOAD_S3_URL}/default-profile.jpg`}
                    alt="Preview"
                    style={{ width: 150, height: "auto", borderRadius: 4 }}
                />
            }
            placement="left"
            arrow
        >
            <Avatar alt="" src={`${configs.FILE_UPLOAD_S3_URL}/${profileImageKey}`} />
        </Tooltip>
    );
}

export default ProfileImage;